import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFireExtinguisher: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconFireExtinguisher"><Path d="M14.5 21.5V12.5C14.5 10.567 12.933 9 11 9C9.067 9 7.5 10.567 7.5 12.5V21.5H14.5Z" stroke="currentColor"/><Path d="M11 9V4.25C11 3.2835 10.2165 2.5 9.25 2.5C8.2835 2.5 7.5 3.2835 7.5 4.25C7.5 5.2165 8.2835 6 9.25 6H10.625" stroke="currentColor"/><Path d="M20.5 8V4L13.5 4.8V7.2L20.5 8Z" stroke="currentColor"/><Path d="M13.5 6H10.0249C7.17234 6 4.78384 8.16156 4.5 11" stroke="currentColor"/></CentralIconBase>;
});

export default IconFireExtinguisher;
